import React, {useContext, useEffect, useState} from "react";
import DetailsComponent from "./DetailsComponent";
import {SubtitleDetail, ListDetail, TextDetail, PreStyled, ColDetail, DisableNext, ActionNext, ListThemes} from "./Styles";
import {useLocation, useParams} from "react-router-dom";
import {CoursesContext} from "../../../context/CoursesContext";
import {LoadComponet} from "../../../components/loaders/Loader";
import styled from "styled-components";
import parse from "html-react-parser";
import {NextCoursesservice} from "../../../services/CoursesServices";

export function ThemaryComponent() {
   const {getThemary, themaryCourse} = useContext(CoursesContext);
   let {id} = useParams();

   useEffect(() => {
      if (id) {
         getThemary(id);
      }
   }, [id]);

   if (themaryCourse.isLoading) return <LoadComponet />;

   if (themaryCourse.data.length === 0) return null;

   return (
      <DetailsComponent title="Temario" iconTitle={require("../../../assets/icons/themary.png")} iconClass="large" titleClass="centerDesk">
         <div>
            {React.Children.toArray(
               themaryCourse.data.map((theme) => {
                  return (
                     <>
                        <SubtitleDetail className="light">{theme.title}</SubtitleDetail>
                        <ListThemes>
                           {React.Children.toArray(
                              theme.data.map((subth) => {
                                 return (
                                    <TextDetail as="li" className="itemList">
                                       {subth.name}
                                    </TextDetail>
                                 );
                              }),
                           )}
                        </ListThemes>
                     </>
                  );
               }),
            )}
         </div>
      </DetailsComponent>
   );
}

export function ProfileComponent() {
   const {courseData} = useContext(CoursesContext);

   if (courseData.isLoading) return <LoadComponet />;

   return (
      <DetailsComponent title="Perfil de egreso" iconTitle={require("../../../assets/icons/rank.png")} titleClass="centerDesk">
         <div>
            {/* <TextDetail style={{marginBottom: "1em"}}>Al final del curso serás capaz de:</TextDetail> */}

            <PreStyled>{courseData.graduateProfile ? parse(courseData.graduateProfile) : ""}</PreStyled>
            {/* <TextDetail as="li">{}</TextDetail> */}
            {/* <TextDetail as="li">El proceso de elaboración de vinos tintos, blancos, espumosos y rosados</TextDetail>
               <TextDetail as="li">El efecto de las barricadas y añejamiento en el vino</TextDetail>
               <TextDetail as="li">Los básicos de viticultura</TextDetail>
               <TextDetail as="li">La historia y desarrollo del vino</TextDetail> */}
         </div>
      </DetailsComponent>
   );
}
export function NextCourses() {
   const [nextss, setNextss] = useState([]);

   useEffect(() => {
      getNextC();
   }, []);

   const getNextC = () => {
      NextCoursesservice()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            let newN = data.map((cours) => printMonth(cours.startDate));
            setNextss(newN);
         })
         .catch((e) => {
            console.log(e);
         });
   };

   return (
      <DetailsComponent title="Próximos cursos" iconTitle={require("../../../assets/icons/calendar.png")} titleClass="centerDesk">
         {/* <ColDetail>
            <TextDetail className="date">Febrero 2020</TextDetail>
            <ActionNext className="textNextCourse" to={`${location.pathname}?modal=true`}>
               Inscribirme{" "}
               <span>
                  <img src={require("../../../assets/icons/to_right.png")} alt="next" className="mediaIcon" />
               </span>
            </ActionNext>
         </ColDetail> */}
         {/* <ColDetail>
            <TextDetail className="date">Junio 2020</TextDetail>
            <DisableNext className="textNextCourse">Próximamente</DisableNext>
         </ColDetail> */}

         {React.Children.toArray(
            nextss.map((nextDate, index) => {
               if (index >= 5) return false;
               return (
                  <ColDetail>
                     <TextDetail className="date">{nextDate}</TextDetail>
                     <DisableNext className="textNextCourse">Próximamente</DisableNext>
                  </ColDetail>
               );
            }),
         )}
      </DetailsComponent>
   );
}

const printMonth = (num) => {
   let months = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
   ];
   let mm = Number(num.substring(5, 7)) - 1;
   let dd = Number(num.substring(8, 10));
   return months[mm] + ", " + dd;
};

export function ResourceLirary() {
   const {docsCourse} = useContext(CoursesContext);

   if (docsCourse.isLoading) return <LoadComponet />;

   if (docsCourse.data.length > 0) {
      return (
         <DetailsComponent
            title={<span>Librería de recursos</span>}
            iconClass="min"
            iconTitle={require("../../../assets/icons/arrow_down.png")}
            titleClass="centerDesk"
         >
            <div>
               <TextDetail style={{marginBottom: "0.9em"}}>Descarga las guías del curso y refuerza tus conocimientos.</TextDetail>
               {React.Children.toArray(
                  docsCourse.data.map((doc) => {
                     return (
                        <TextDetail>
                           {doc.resourceName}
                           <DownLink href={"http://domecqapi.trebolbit.com/" + doc.pathResource} target="_blanck" download>
                              <img src={require("../../../assets/icons/media_down.png")} alt="down" className="mediaIcon" />
                           </DownLink>
                        </TextDetail>
                     );
                  }),
               )}
            </div>
         </DetailsComponent>
      );
   }
   return null;
}

const DownLink = styled.a``;
